export default `
query customer($from: String, $to: String, $currentPage: Int = 1, $pageSize: Int = 5) {
    customer {
        orders(
            scope: WEBSITE
            currentPage: $currentPage
            pageSize: $pageSize
            filter: { created_at: { from: $from, to: $to } }
            sort: { sort_direction: DESC, sort_field: CREATED_AT }
        ) {
            items {
                status
                shipment_status
                order_date
                order_number
            }
        }
    }
}
`
